import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { LyearnLogo } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { useAppConfig } from '@/hooks/useAppConfig';

function SidebarHeader({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { site } = useAppConfig();
  const { logoUrl, appUrl, appUrlTarget, name } = site;

  return (
    <Stack
      alignItems="center"
      className={cn('sticky top-0 z-50 h-50 flex-shrink-0 bg-white ps-12', className)}>
      <a href={appUrl || '/'} rel="noreferrer" target={appUrlTarget}>
        {logoUrl ? (
          <Image
            useImg
            alt={t('Common:LogoOfImage', { imageAlt: name })}
            className="h-28 rounded-4"
            src={logoUrl}
          />
        ) : (
          <LyearnLogo className="h-28 rounded-4" fill="currentColor" />
        )}
      </a>
    </Stack>
  );
}

export default React.memo(SidebarHeader);
